/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import VirtualNumbersModal from './VirtualNumbersModal'
import {Elements} from '@stripe/react-stripe-js'
import moment from 'moment'
import WSButton from '../../../../../_metronic/helpers/components/WSButton/WSButton'

import {stopLoading, startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import UnSubscribeDedicatedNumber from './Modal/UnSubscribeDedicatedNumber'

import {
  fetchAsyncSetDefaultNumbers,
  getDedicatedNumber,
  getDedicatedNumberList,
  unSubscribeDedicatednumber as unSubscribe,
} from './DedicatedNumberSlice/DedicatedNumberSlice'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {KTSVG} from '../../../../../_metronic/helpers'
import {DedicatedNumberBadge} from '../../../../Utils/Constant/ArrayOfSideNav'
import InsertNewData from '../../../../Components/InsertNewData'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import StripeJSProvider from '../../../../Utils/StripeJSProvider'
import {
  getAllUserDetails,
  getDefaultRegion,
  getIsDefaultRegion,
} from '../Overview/OverviewSlice/UserDetailsSlice'
import NodataYet from '../../../../Components/NodataYet'
import {addTax} from '../../../../Utils/_helpers'
import {DedicatedNumber} from '../../../../../services/cellcast.v2.types'
import {REGION} from '../../../../Utils/Constant/ConstantForWebsite'
import _ from 'lodash'

type Props = {
  showModalNew: boolean
  setShowModalNew: (visible: boolean) => void
  setShowCredit: (visible: boolean) => void
  onClickLearnMore: () => void;
}

const DedicatedNumberList: React.FC<Props> = ({showModalNew, setShowModalNew, setShowCredit, onClickLearnMore}) => {
  const dispatch = useDispatch()
  const DedicatedNumber: any = useSelector(getDedicatedNumber)
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const userRegion = useSelector(getDefaultRegion)

  const [resubscribe, setResubcribe] = useState(false)
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [unsubscribedIds, setUnsubscribedIds] = useState<any>('')

  useEffect(() => {
    if (confirm == true) {
      dispatch(unSubscribe(unsubscribedIds))
      setConfirm(false)
      setResubcribe(false)
    }
  }, [confirm])

  useEffect(() => {
    dispatch(getDedicatedNumberList())
    dispatch(stopLoading())
  }, [])

  const setDefultNumber = (id: any) => {
    dispatch(fetchAsyncSetDefaultNumbers(id))
  }

  const userData: any = useSelector(getAllUserDetails)
  const [isShowCredit, setIsShowCredit] = useState(true)
  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsShowCredit(false)
        setShowCredit(false)
      }
    }
  }, [userData])

  /////////////////////////////////use-MEMO//////////////////////////////////////
  const confirmation = useMemo(
    () => (
      <UnSubscribeDedicatedNumber
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Confirm to delete'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )
  const handleUnsubscribe = (id: any) => {
    setOpen(true)
    setUnsubscribedIds(id)
  }

  const isShareNumber = useCallback(
    (senderData: DedicatedNumber) => {
      if (senderData && senderData.allocatedUsers && Array.isArray(senderData.allocatedUsers)) {
        const userID = userData._id

        if (userID && senderData.allocatedUsers.includes(userID)) {
          return true
        }
      }
      return false
    },
    [userData]
  )

  return (
    <>
      {confirmation}
      <StripeJSProvider>
        {({stripe}: any) =>
          stripe ? (
            <Elements stripe={stripe}>
              <VirtualNumbersModal
                show={showModalNew}
                handleClose={() => {
                  setShowModalNew(false)
                  setResubcribe(false)
                }}
                resubscribe={resubscribe}
                dedicatedNumber={DedicatedNumber?.filter(
                  (it: any) =>
                    it.status === 'inactive' ||
                    (it?.billingStatus === 'free' && it?.status === 'active')
                )}
              />
            </Elements>
          ) : null
        }
      </StripeJSProvider>
      <div className={`card virtual-table`}>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <div>
              <span className='card-label fw-bolder fs-2 mb-1 small-title'>Dedicated Numbers</span>
              <i
                onClick={() => onClickLearnMore()}
                className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
              />
            </div>
          </h3>
          {[REGION.AU, REGION.US, REGION.UK].includes(_.toLower(userRegion)) &&
            AuthenticateUser('purchase-dedicated-number') &&
            isShowCredit && (
              <div className='card-toolbar align-items-start flex-column'>
                <a
                  data-testid='btnAddDedicatedNumber'
                  href='#'
                  className='btn btn-sm btn-primary fw-500'
                  onClick={() => setShowModalNew(true)}
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-6' />
                  New dedicated number
                </a>
              </div>
            )}
        </div>
        {DedicatedNumber?.length > 0 ? (
          <div className='card-body'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-100 align-middle gs-0 gy-6'>
                <thead>
                  <tr className='fw-400 text-dark text-muted '>
                    <th className=' rounded-start'>NUMBER</th>
                    <th className=''>TOTAL</th>
                    <th className=''>PLAN</th>
                    <th className=''>ACTIVATION</th>
                    <th className=''>Type</th>
                    <th className=''>EXPIRATION</th>
                    <th className=''>GRACE PERIOD</th>
                    <th className=''>STATUS</th>
                    {isShowCredit && <th className=' text-center'>ACTIONS</th>}
                  </tr>
                </thead>
                <tbody>
                  {DedicatedNumber?.map((data: any, idx: number) => (
                    <tr key={idx} className=''>
                      <td className=''>
                        <a
                          //   href='#'
                          className='text-dark fw-bolder  d-block mb-1 fs-6'
                        >
                          {data?.audNumber}
                        </a>
                      </td>
                      <td>$ {addTax(+data?.totalAmount?.toFixed(2)) || 0}</td>
                      <td>
                        <span>{data?.billingStatus?.toUpperCase()}</span>
                      </td>
                      <td>
                        {data?.activationTime !== null
                          ? moment(data?.activationTime)?.format('DD/MM/YYYY')
                          : ''}
                      </td>
                      <td>
                        <span
                          className={
                            data?.type?.toUpperCase() === 'MMS'
                              ? 'badge badge-light-info fs-7 blue_text_badge badge-square p-4 py-5'
                              : 'badge badge-light-success green_text_badge badge-square p-4 w-50px py-5'
                          }
                        >
                         {data?.type?.toUpperCase() === 'MMS' ? 'MMS + SMS' : data?.type}
                        </span>
                      </td>
                      <td>
                        {data?.expirationTime !== null
                          ? moment(data?.expirationTime).format('DD/MM/YYYY')
                          : ''}
                      </td>
                      <td>
                        {data?.gracePeriodEndTime
                          ? moment(data?.gracePeriodEndTime).format('DD/MM/YYYY')
                          : ''}
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            DedicatedNumberBadge?.status?.[data?.status]
                          } badge-square p-4 py-5`}
                        >
                          {data?.status?.toUpperCase()}
                        </span>
                      </td>

                      {!isShareNumber(data) ? (
                        <td className='text-center'>
                          {['active', 'inactive'].includes(data.status) && (
                            <div className='d-flex justify-content-center flex-shrink-0'>
                              {data?.status === 'active' &&
                                AuthenticateUser('create-custom-number') &&
                                (data?.isDefault === true ? (
                                  <label
                                    onClick={() => {
                                      setDefultNumber({
                                        dedicatedNumberId: data?._id,
                                        isDefault: false,
                                      })
                                    }}
                                    className='btn btn-sm btn-light-primary border-light-primary border-dashed me-5'
                                  >
                                    {' '}
                                    Default
                                  </label>
                                ) : (
                                  <label
                                    className='btn btn-sm btn-light-primary border-light-primary border-dashed me-5'
                                    onClick={() => {
                                      setDefultNumber({
                                        dedicatedNumberId: data?._id,
                                        isDefault: true,
                                      })
                                    }}
                                  >
                                    Set default
                                  </label>
                                ))}
                              
                              {AuthenticateUser('create-custom-number') && data?.status !== 'pending' &&(
                                <div className='menu-item'>
                                  <label
                                    className='btn btn-sm btn-light-primary border-light-primary border-dashed me-5'
                                    data-kt-users-table-filter='delete_row'
                                    onClick={() => {
                                      if (
                                        data?.status === 'active' &&
                                        data?.billingStatus !== 'free'
                                      ) {
                                        handleUnsubscribe(data?._id)
                                      } else {
                                        setShowModalNew(true)
                                        setResubcribe(true)
                                      }
                                    }}
                                  >
                                    {data?.billingStatus === 'free' && data?.status === 'active'
                                      ? 'Subscribe'
                                      : data.status === 'active'
                                      ? 'Unsubscribe'
                                      : 'Subscribe'}
                                  </label>
                                </div>
                              )}
                            </div>
                          )}

                          {/* <div className='d-flex justify-content-center flex-shrink-0'>
                          <label className='btn btn-sm btn-light-primary border-light-primary border-dashed me-5'>
                            Re-Purchase
                          </label>
                        </div> */}
                        </td>
                      ) : (
                        <div className='d-flex justify-content-center flex-shrink-0'>--</div>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : isShowCredit ? (
          <InsertNewData
            message={{
              title: 'No Dedicated Numbers setup (yet!)',
              subtitle: `It looks like you haven't purchased any dedicated numbers, get started to take full advantage of our inbox feature!`,
            }}
            roleCheck='purchase-dedicated-number'
            buttonName={{
              name: 'New dedicated number',
              link: '/new-message',
              popup: true,
              buttonFun: () => setShowModalNew(true),
            }}
          />
        ) : (
          <NodataYet message='No Dedicated Numbers setup (yet!)' />
        )}
      </div>
    </>
  )
}

export default React.memo(DedicatedNumberList)
